// src/pages/Home.jsx
import React from 'react';
import { motion } from 'framer-motion';
import Features from '../components/Features';
import Download from '../components/Download';

export default function Home() {
  return (
    <div>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <Features />
      </motion.div>
      <motion.div
        id="download" // ✅ Якорь для ссылки из Header
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.2 }}
      >
        <Download />
      </motion.div>
    </div>
  );
}